/**
 * FamilyMemberEvents
 *
 * Simple event emitter for family member changes.
 * Allows components like the calendar to subscribe to updates.
 */

type EventListener = () => void;

class FamilyMemberEventsManager {
  private listeners: Set<EventListener> = new Set();

  /**
   * Subscribe to family member changes
   * Returns an unsubscribe function
   */
  subscribe(listener: EventListener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  /**
   * Emit a members changed event to all subscribers
   */
  emitMembersChanged(): void {
    this.listeners.forEach(listener => {
      try {
        listener();
      } catch (error) {
        console.error('[FamilyMemberEvents] Listener error:', error);
      }
    });
  }
}

export const FamilyMemberEvents = new FamilyMemberEventsManager();
